import type { ReactNode } from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { getClerkSatelliteConfig } from '@/lib/auth';

type ClerkProviderWithRouterProps = {
  children: ReactNode;
};

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY');
}

const ClerkProviderWithRouter = ({ children }: ClerkProviderWithRouterProps) => {
  const navigate = useNavigate();
  const satelliteConfig = getClerkSatelliteConfig();
  const handleRouterPush = (to: string) => navigate(to);
  const handleRouterReplace = (to: string) => navigate(to, { replace: true });

  if (satelliteConfig) {
    return (
      <ClerkProvider
        publishableKey={publishableKey}
        routerPush={handleRouterPush}
        routerReplace={handleRouterReplace}
        domain={satelliteConfig.domain}
        isSatellite
        signInUrl={satelliteConfig.signInUrl}
        signUpUrl={satelliteConfig.signUpUrl}
      >
        {children}
      </ClerkProvider>
    );
  }

  return (
    <ClerkProvider
      publishableKey={publishableKey}
      routerPush={handleRouterPush}
      routerReplace={handleRouterReplace}
    >
      {children}
    </ClerkProvider>
  );
};

export default ClerkProviderWithRouter;
